export const AppRoute = {
  SELECT_GROUP: 'select-group',
  SETTINGS: 'settings',
  SETTINGS_LANGUAGES: 'settings-languages',
  SETTINGS_CONTACT: 'settings-contact',
  MAP: 'map',
  SCHEDULES: 'schedules',
  SEARCH: 'search',
  ROUTE_LIST: 'route-list',
  ROUTE_DETAILED: 'route-detailed',
  ON_DEMAND_ROUTE_DETAILED: 'on-demand-route-detailed',
  STOP_LIST: 'stop-list',
  STOP_DETAILED: 'stop-detailed',
  TRIP_DETAILED: 'trip-detailed',
  ITINERARY: 'itinerary',
  PASSENGER_MESSAGE: 'passenger-message',
  ROUTE_ALERTS: 'route-alerts',
  TIMETABLE: 'timetable',
  TRAIN_DEPARTURES: 'train-departures',
};
